import lowerCase from 'lodash-es/lowerCase'
import startCase from 'lodash-es/startCase'

export const normalizeLabel = (label: string) => startCase(lowerCase(label))
